var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2003 2.85047C12.2299 3.86117 14.3249 5.83709 15.2813 6.91806H1.05597C-0.351992 6.91806 -0.35199 9.08199 1.05597 9.08199H15.2813C14.3249 10.163 12.2299 12.1389 11.2003 13.1496C10.1971 14.1343 11.7401 15.6663 12.7383 14.6865C13.8852 13.5607 16.147 11.4802 17.1603 10.2305C18.2711 8.8606 18.2887 7.16119 17.1603 5.7695C16.1562 4.53122 13.8744 2.42873 12.7383 1.31352C11.7401 0.333705 10.1971 1.86574 11.2003 2.85047Z",
    fill: "#9EA7AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.f3c2abe7cb79c9095e7e661fa18fe874.svg";
export { ForwardRef as ReactComponent };